export type DraftJsContent = {
  blocks?: Array<{ text?: string | null }> | null;
} | null;

export function draftJsContentToPlainText(content?: DraftJsContent): string {
  const blocks = content?.blocks;
  if (!Array.isArray(blocks)) {
    return '';
  }

  return blocks
    .map((block) => block?.text ?? '')
    .join('\n')
    .trim();
}

/** GraphQL may return plain text or a DraftJS `{ blocks }` object for the same field. */
export function normalizeTextContent(value: unknown): string {
  if (typeof value === 'string') {
    return value.trim();
  }

  if (value && typeof value === 'object') {
    return draftJsContentToPlainText(value as DraftJsContent);
  }

  return '';
}

export function pickPlainTextOrDraftContent(
  plainText?: string | null,
  draftContent?: unknown
): string {
  const trimmedPlainText = plainText?.trim();
  if (trimmedPlainText) {
    return trimmedPlainText;
  }
  return normalizeTextContent(draftContent);
}

export function orderRecordsByIds<RecordType extends { _id: string }>(
  records: RecordType[],
  orderedIds: string[]
): RecordType[] {
  const recordsById = new Map(records.map((record) => [record._id, record]));

  return orderedIds
    .map((recordId) => recordsById.get(recordId))
    .filter((record): record is RecordType => Boolean(record));
}
